import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=16a6ae38&%3Astyle=%7B%20'background-image'%3A%20'url('%20%2B%20img%2FDXC_AWS.jpg%20%2B%20')'%20%7D&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports